import { FuseRouteItemType } from "@fuse/utils/FuseUtils";
import SignOutPageView from "./components/SignOutPage.view";
import SignInPageView from "./components/SignInPage.view";
import { LOGIN_UNIFICADO } from "@/configs/runtime";

const route: FuseRouteItemType = {
	children: [
		{
			path: "sign-in",
			element: <SignInPageView />,
			settings: {
				layout: {
					config: {
						navbar: {
							display: false,
						},
						toolbar: {
							display: false,
						},
						footer: {
							display: false,
						},
						leftSidePanel: {
							display: false,
						},
						rightSidePanel: {
							display: false,
						},
					},
				},
			},
			auth: [], // onlyGuest
		},
		{
			path: "sign-out",
			element: <SignOutPageView />,
			settings: {
				layout: {
					config: {
						navbar: {
							display: false,
						},
						toolbar: {
							display: false,
						},
						footer: {
							display: false,
						},
						leftSidePanel: {
							display: false,
						},
						rightSidePanel: {
							display: false,
						},
					},
				},
			},
			auth: null,
		},
	],
};

if (LOGIN_UNIFICADO) route.children.push({ ...route.children[0], path: "g/:slug" });

export default route;
